import { Orb } from "./Orb";

/**
 * Hero illustration on the entry screen — same swirly-green Orb (in
 * `compact` decorative mode) with sparkle accents around it. Reusing the
 * live Orb means the visual on the welcome card is unmistakably the same
 * thing the participant will talk to in a moment.
 */
export function InterviewHero() {
  return (
    <div
      aria-hidden
      className="relative w-full flex items-center justify-center overflow-hidden"
    >
      <Sparkle className="absolute top-[6%] left-[12%]" size={16} />
      <Sparkle className="absolute top-[2%] left-[42%]" size={11} />
      <Sparkle className="absolute top-[22%] right-[10%]" size={16} />
      <Sparkle className="absolute top-[44%] left-[3%]" size={12} />
      <Sparkle className="absolute top-[38%] right-[4%]" size={14} />
      <Sparkle className="absolute bottom-[8%] left-[16%]" size={11} />
      <Sparkle className="absolute bottom-[4%] right-[18%]" size={13} />
      <Orb compact active={false} level={0} />
    </div>
  );
}

function Sparkle({
  className,
  size = 12,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden
    >
      <path
        d="M12 2 L13 11 L22 12 L13 13 L12 22 L11 13 L2 12 L11 11 Z"
        fill="#3A7968"
        opacity="0.85"
      />
    </svg>
  );
}
